import { ApolloError } from "@apollo/client";
import { IMachineCenterFailureDetailsInfoBO, IOeeProduct } from "entities/MachineCenters/MachineCentersInterfaces";
import { IMachineCenterToDuplicate } from "../../components/ProductionLineAccordion/ProductionLineAccordionInterfaces";

export interface IMachineCenterCreationFormValues {
    name: string;
    short_name: string;
    manufacturer: string;
    model_number: string;
    downtime_method_capture_id: number | string;
    plc_address: string;
    minimum_downtime: number | string;
    downtime_trigger_threshold: number | string;
    is_bottleneck: boolean;
    aspen_plus_oee_enabled: boolean;
    oee_input_method_id: number | "";
    oee_products: IOEEFormProducts[];
    record_quality_enabled: boolean;
    quality_manual_entry: boolean;
    quality_calculation_method_id: number | "";
    is_duplication_with_selection: boolean;
    is_duplication_without_selection: boolean;
    production_line_id_send_duplicate?: number | string;
    production_line_id_to_duplicate?: number | string;
    machine_center_id_to_duplicate?: number | string;
}

export interface IMachineCenterCreationForm {
    apolloMutationError: ApolloError | undefined;
    handleSubmit: (
        values: IMachineCenterCreationFormValues,
        duplicationValues?: IMachineCenterFailureDetailsInfoBO,
    ) => Promise<void>;
    handleClose: () => void;
    isEdit?: boolean;
    machineCenter?: IMachineCenterCreationFormValues;
    millId: number;
    machineCenterId?: number;
    duplicateMachineCenterInfo?: IMachineCenterToDuplicate;
    /** When true, Aspen+ (OEE) toggle and Performance tab are shown. When false, they are hidden. */
    isMillAspenPlusEnabled?: boolean;
}

export interface IOEEFormProducts extends Omit<IOeeProduct, "id"> {
    id?: number;
    deleted_at?: Date;
    _original_ideal_value?: number;
}

export enum OEETabsEnums {
    GENERAL = 0,
    PERFORMANCE = 1,
    QUALITY = 2,
}
